export const initProcessSection = () => {
	const root = document.querySelector(".process");
	const slider = root?.querySelector(".process__slider");

	if (!root || !slider || typeof Swiper === "undefined") {
		return;
	}

	if (slider.swiper) {
		slider.swiper.destroy(true, true);
	}

	return new Swiper(slider, {
		slidesPerView: "auto",
		spaceBetween: 8,
		centeredSlides: false,
		loop: false,
		speed: 600,
		grabCursor: true,
		allowTouchMove: true,
		simulateTouch: true,
		watchOverflow: true,
		resistanceRatio: 0.85,
		observer: true,
		observeParents: true,
	});
};
